import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, Toast } from "primereact";
import { FileUpload } from "primereact/fileupload";
import { Carousel } from "primereact/carousel";

import { downloadFile, uploadHandlerFirma } from "../../../Base/Services/ArchivosService";
import { toastShow } from "../../../Base/Services/ToastService";

import { descargarFirma, eliminarFirma, getFirmasPersonales, mostrarFirma } from "../../../API/IT/Usuarios/UsersRequests";


const AgregarFirma = ({showAddFirma, setShowAddFirma, userEdit, toast}) => {

    const fileUpload = useRef(null);
    const [listadoArchivos, setListadoArchivos] = useState([]);
    const [showModalImagenes, setShowModalImagenes] = useState(false);
    const [imagenes, setImagenes] = useState([]);
    // const toast = useRef(null);


    const referencia = {
        IdRef: userEdit?.idUser,
        Codigo: userEdit?.idPersonal,
    };

    const subirFirma = async (e) => {
        const archivosGuardados = await getArchivos();
        if(referencia.Codigo === undefined){
          toastShow(
            toast,
            "warn",
            "Advertencia",
            "Guarde el usuario antes de agregar la firma."
          );
        } else{
    
          const imagenCorrespondiente = archivosGuardados?.find( (archivo) => archivo.startsWith(userEdit?.idPersonal) );
    
          if (imagenCorrespondiente) {
            toastShow(toast, "error", 'Error', "Solo se permite subir 1 firma.");
            return;
          }
      
          const inputs = [
            {
              name: "IdRef",
              type: "text",
              value: referencia.IdRef,
            },
            {
              name: "Codigo",
              type: "text",
              value: referencia.Codigo,
            },
          ];
          uploadHandlerFirma({ e, inputs, toast, ref: fileUpload, getArchivos });
          getArchivos();
            setTimeout(() => {
                onHide()
            }, 1200);
        }
    };

    const getArchivos = async () => {
        const a = await getFirmasPersonales(userEdit?.idPersonal);
        if (a?.length > 0) {
            const imagenCorrespondiente = a.find(e => e.startsWith(userEdit?.idPersonal));
            if (imagenCorrespondiente) {
              try {
                setListadoArchivos([imagenCorrespondiente]);
              } catch (error) {
                setListadoArchivos([]);
              }
            } else {
              setListadoArchivos([]);
            }
        } else {
          setListadoArchivos([]);
        }
        return a;
    };

    const descargarArchivo = async (nombre) => {
        const a = await descargarFirma(userEdit?.idPersonal, nombre);
        downloadFile(a, nombre);
    };

    const eliminar = async (nombre) => {
        const a = await eliminarFirma(userEdit?.idPersonal, nombre);
        toastShow(toast, "success", "Eliminado", "Firma eliminada correctamente.");
        setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== nombre));
    };

    const verImagenes = async () => {
        if (imagenes.length === 0) {
          toastShow(
            toast,
            "warn",
            "Advertencia",
            "Este usuario no tiene firma."
          );
        } else {
          setShowModalImagenes(true);
        }
    };

    const getImagenes = async () => {
        const i = await getFirmasPersonales(userEdit?.idPersonal);
        if (i?.length > 0) {
            const imagenCorrespondiente = i.find(e => e.startsWith(userEdit?.idPersonal));
            if (imagenCorrespondiente) {
                try {
                    const a = await mostrarFirma(userEdit?.idPersonal, imagenCorrespondiente);
                    setImagenes({ Codigo: userEdit?.idPersonal, img: [a] });
                } catch (error) {
                    console.error(error);
                    setImagenes([]);
                }
            } else {
                setImagenes([]);
            }
        } else {
            setImagenes([]);
        }
    };
    

    useEffect((userEdit) => {
        getImagenes();
        getArchivos()
    }, [userEdit]);




    const onHide = () =>{
        setShowAddFirma(false)
    }

    const cerrarModal = () => {
        setShowModalImagenes(false);
    };


  return (
    <div>
      <ConfirmDialog />
      <Dialog
        visible={showAddFirma}
        modal
        className="modal__contenedor modal__usuarios"
        onHide={onHide}
        header={'Agregar Firma a ' + userEdit?.UserName}
      >
      <Toast toast={toast}/>
        <div id="Dialog">
        <div  className="d-flex align-items-center flex-wrap">
            <div className="modal__input-contenedor"> 
                <div className="field col-12 me-2">
                <FileUpload
                    ref={fileUpload}
                    name="demo"
                    url="./upload"
                    multiple
                    customUpload
                    uploadHandler={subirFirma}
                    maxFileSize={40000000}
                    />
                    <div className="mt-3">
                        <div>
                            {listadoArchivos?.map((a, i) => (
                            <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                            >
                                <div className="col-10">{a}</div>
                                <Button
                                icon="pi pi-download"
                                onClick={() => descargarArchivo(a)}
                                />
                                <Button
                                icon="pi pi-trash"
                                severity="danger"
                                onClick={() => eliminar(a)}
                                />
                            </div>
                            ))}
                        </div>
                    </div>
                    <div style={{ top: 350, right: 22 }} className="d-flex justify-content-end">
                    <Button
                        className={"mt-3"}
                        label="Ver Firma"
                        onClick={() => verImagenes()}
                    />
                    </div>
                </div>
            </div>
        </div>
        </div>
      </Dialog>


      
      {/* Dialogo para mostrar imagenes */}
      <Dialog header={userEdit?.UserName} visible={showModalImagenes} onHide={cerrarModal} className="w-50">
        <div style={{ maxWidth: "100%" }}>
          {imagenes.Codigo && (
            <Carousel
              value={imagenes.img}
              circular
              showIndicators={true}
              itemTemplate={(item) => {
                return (
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: "600px",
                    }}
                  >
                    <img
                      src={"data:image/png;base64," + item}
                      alt="imagen"
                       style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                    />
                  </div>
                );
              }}
            />
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default AgregarFirma;
